export const TOGGLE_LOADING = 'TOGGLE_LOADING';

export default {
  TOGGLE_LOADING,
};
